import { render, staticRenderFns } from "./PreferredLanguage.vue?vue&type=template&id=7cc08c36&scoped=true&"
import script from "./PreferredLanguage.vue?vue&type=script&lang=js&"
export * from "./PreferredLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc08c36",
  null
  
)

export default component.exports